export default {
      id: "arrow-left-alt-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#arrow-left-alt-usage",
      toString: function () {
        return this.url;
      }
    }